import type { PaginationMetadata, PaginationQuery } from "./common";

export const RECEIVABLE_STATUSES = [
  "open",
  "overdue",
  "settled",
] as const;

export type ReceivableStatus = (typeof RECEIVABLE_STATUSES)[number];

export const RECEIVABLE_PAYMENT_STATUSES = [
  "pending",
  "verified",
] as const;

export type ReceivablePaymentStatus =
  (typeof RECEIVABLE_PAYMENT_STATUSES)[number];

export const RECEIVABLE_PAYMENT_METHODS = [
  "cash",
  "edc",
  "qris",
  "app_qris",
  "bank_transfer",
] as const;

export type ReceivablePaymentMethod =
  (typeof RECEIVABLE_PAYMENT_METHODS)[number];

export interface ReceivablePayment {
  id: string;
  workspaceId: string;
  saleId: string;
  code: string | null;
  date: string;
  amount: number;
  method: ReceivablePaymentMethod;
  verificationStatus: ReceivablePaymentStatus;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ReceivableItem {
  productName: string;
  qty: number;
  sellingPrice: number;
}

export interface Receivable {
  saleId: string;
  workspaceId: string;
  date: string;
  customerName: string;
  transactionCode: string | null;
  items: ReceivableItem[];
  totalAmount: number;
  paidAmount: number;
  remainingAmount: number;
  dueDate: string;
  ageDays: number;
  status: ReceivableStatus;
  collectorName: string | null;
  notes: string | null;
  payments: ReceivablePayment[];
}

export interface CreateReceivablePaymentReq {
  date: string;
  amount: number;
  method: ReceivablePaymentMethod;
  verificationStatus?: ReceivablePaymentStatus;
  notes?: string;
}

export interface UpdateReceivablePaymentReq {
  date?: string;
  amount?: number;
  method?: ReceivablePaymentMethod;
  verificationStatus?: ReceivablePaymentStatus;
  notes?: string;
}

export interface UpsertReceivableMetaReq {
  collectorName?: string | null;
  notes?: string | null;
}

export interface GetReceivableReq {
  q?: string;
  status?: ReceivableStatus;
  dateFrom?: string;
  dateTo?: string;
  pagination?: PaginationQuery;
}

export interface ReceivableList {
  items: Receivable[];
  pagination: PaginationMetadata;
}
